import * as actionTypes from './actionTypes';
import { apiFunction } from "../../apiCalls/functions"
import { ALL_ORDER, APPROVE_COD, EXPORT_TO_CSV, ORDER_PAPER, UPDATE_PAPER_BUNDLE, UPDATE_PAPER_CUSTOM, EDIT_ORDER_TOKEN } from "../../apiCalls/urls/order"
import { apiLoading, apiLoadingEnd } from "../../store/notification/action";
import { actionNotifier } from "../../components/ui/toast";
import { getDataFromStore } from "../../store/getStore";
import fileDownload from 'js-file-download';
import { apiLoadingOverlay, apiLoadingOverlayEnd } from '../../store/loader/loadingSlice';


//AllAPIS
export const fetchOrder = async (data, page, items) => {
    return await apiFunction(ALL_ORDER + `?page=${page}&items=${items}`, 'post', data, true, false)
}

export const fetchOrderPaper = async (id) => {
    return await apiFunction(ORDER_PAPER + id, 'get', {}, true, false)
}
export const fetchEditOrderToken = async (id) => {
    return await apiFunction(EDIT_ORDER_TOKEN + id, 'get', {}, true, false)
}
export const updatePaperBundle = async (data) => {
    return await apiFunction(UPDATE_PAPER_BUNDLE, 'post', data, true, false)
}
export const updatePaperCustom = async (data) => {
    return await apiFunction(UPDATE_PAPER_CUSTOM, 'post', data, true, false)
}
export const approveCOD = async (id) => {
    return await apiFunction(APPROVE_COD + id, 'post', {}, true, false)
}
export const exportToCSV = async (data) => {
    let res = await apiFunction(EXPORT_TO_CSV, 'post', data, true, "blob")
        ;
    let fileName = 'orders' + Date.now() + '.csv';
    fileDownload(res, fileName);
}
export const getOrderCounselorOrMentor = async (id) => {
    let res = await apiFunction(`/admin/counselor/order-counselor/${id}`, 'get', {}, true, false)
    return res
}

export const updateOrderCounselorOrMentor = async (data) => {
    return await apiFunction("/admin/counselor/order-counselor", 'post', data, true, false)
}


export const onLoad = () => {
    return async (dispatch) => {
        dispatch(onFetchOrder())
    }
}

export function onApproveCOD(id) {
    return async (dispatch) => {
        dispatch(apiLoadingOverlay())
        let result = await approveCOD(id);
        if (result.status) {
            dispatch(onFetchOrder())
        }
        else {

        }
        dispatch(apiLoadingOverlayEnd())
    }
}
export function onUpdatePaperBundle(data, id) {
    return async (dispatch) => {
        dispatch(apiLoadingOverlay())
        let result = await updatePaperBundle(data);
        if (result.status) {
            dispatch(onFetchOrderPaper(id))
        }
        else {

        }
        dispatch(apiLoadingOverlayEnd())
    }
}
export function onUpdatePaperCustom(data, id) {
    return async (dispatch) => {
        dispatch(apiLoadingOverlay())
        let result = await updatePaperCustom(data);
        if (result.status) {
            dispatch(onFetchOrderPaper(id))
        }
        else {

        }
        dispatch(apiLoadingOverlayEnd())
    }
}


export function onFetchEditOrderToken(id, navigate) {
    return async (dispatch) => {
        dispatch(apiLoading())
        let result = await fetchEditOrderToken(id);
        if (result.status) {
            ;
            window.open(process.env.REACT_APP_STUDENT_URL + "plans/bundle/" + result.data.orderId + "/" + result.data.token, '_blank');
        }
        else {

        }
        dispatch(apiLoadingEnd())
    }
}

export function onFetchOrderPaper(id) {
    return async (dispatch) => {
        dispatch(apiLoading())
        let result = await fetchOrderPaper(id);
        if (result.status) {
            dispatch(updateOrderPaper(result.data))
        }
        else {

        }
        dispatch(apiLoadingEnd())
    }
}

export function onFetchOrder() {
    return async (dispatch) => {
        dispatch(apiLoading())
        let orderReducer = getDataFromStore("ViewOrders")
        let result = await fetchOrder(orderReducer.filters, orderReducer.page, orderReducer.items);

        if (result.status) {
            dispatch(updateOrder(result.data.rows, result.data.count))
        }
        else {

        }
        dispatch(apiLoadingEnd())
    }
}

export function onExportToCSV() {
    return async (dispatch) => {
        dispatch(apiLoadingOverlay())
        let orderReducer = getDataFromStore("ViewOrders")
        let result = await exportToCSV(orderReducer.filters);
        dispatch(apiLoadingOverlayEnd())
    }
}

// ACTIONS
export const updateOrder = (data, count) => {
    return {
        type: actionTypes.UPDATE_ORDER,
        payload: { data, count }
    };
}

export const updateOrderPaper = (data) => {
    return {
        type: actionTypes.UPDATE_ORDER_PAPER,
        payload: data
    };
}
export const updateFilters = (data) => {
    return {
        type: actionTypes.UPDATE_FILTER,
        payload: data
    };
}

export const updateReducer = (data, item) => {
    return {
        type: actionTypes.UPDATE_REDUCER,
        payload: { data, item }
    };
}
